import React from "react";
import { InlineMath } from "react-katex";
import FractionInput, {
  formatLatexPreview,
} from "../../../../components/inputs/FractionInput";

export function randInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function randomFrom(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

export function formatNumber(value) {
  if (Number.isInteger(value)) return String(value);
  return String(value).replace(".", ",");
}

export function VolumeInput({
  value,
  onChange,
  disabled,
  label = "V",
  suffixLatex = String.raw`\text{cm}^3`,
}) {
  return (
    <FractionInput
      value={value}
      onChange={onChange}
      disabled={disabled}
      label={label}
      suffixLatex={suffixLatex}
      placeholder="np. 120"
    />
  );
}

export function LengthInput({ value, onChange, disabled, label = "H" }) {
  return (
    <FractionInput
      value={value}
      onChange={onChange}
      disabled={disabled}
      label={label}
      suffixLatex={String.raw`\text{cm}`}
      placeholder="np. 6"
    />
  );
}

export function AreaInput({ value, onChange, disabled, label = "P_p" }) {
  return (
    <FractionInput
      value={value}
      onChange={onChange}
      disabled={disabled}
      label={label}
      suffixLatex={String.raw`\text{cm}^2`}
      placeholder="np. 36"
    />
  );
}

export function readParsed(userAnswer) {
  return userAnswer && typeof userAnswer === "object" ? userAnswer.parsed : NaN;
}

export function checkNumeric(userAnswer, expected, tolerance = 0.01) {
  const parsed = readParsed(userAnswer);
  if (!Number.isFinite(parsed)) return { correct: false };
  return { correct: Math.abs(parsed - expected) <= tolerance };
}

export function renderFractionUserAnswer(userAnswer, label, suffixLatex) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) {
    return <i>(brak odpowiedzi)</i>;
  }
  const suffix = suffixLatex ? `\\,${suffixLatex}` : "";
  return (
    <InlineMath math={`${formatLatexPreview(userAnswer.raw, label)}${suffix}`} />
  );
}
